import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { SERVIDOR } from './../../config';
import axios from 'axios';

const UserRegistration = () => {
  const navigate = useNavigate();
  const [hasValidated, setHasValidated] = useState(false);
  const [userData, setUserData] = useState({
    name: '',
    email: '',
    status: 'pendiente',
    expirationDate: '',
    token: ''
  });

  const validarAdmin = async () => {
    if (hasValidated) return; // Evita validaciones múltiples
    
    try {
      const token = localStorage.getItem('adminToken');
      const response = await axios.post(SERVIDOR + '/api/validar-admin', { adminToken: token });
      const data = response.data;

      if (!data.ok) {
        alert('Acceso denegado');
        navigate('/loginAdmin');
      }
      setHasValidated(true);
    } catch (error) {
      console.error('Error al validar acceso:', error);
      navigate('/loginAdmin');
    }
  };

  useEffect(() => {
    validarAdmin();
  }, []);

  // Function to generate a random token
  const generateToken = () => {
    const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    const tokenLength = 16;
    let token = '';
    for (let i = 0; i < tokenLength; i++) {
      token += characters.charAt(Math.floor(Math.random() * characters.length));
    }
    setUserData(prev => ({
      ...prev,
      token: token
    }));
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setUserData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log('Datos de usuario:', userData);
    
    if (userData.expirationDate) {
      const fechaSeleccionada = new Date(userData.expirationDate);
      console.log('Fecha completa:', fechaSeleccionada.toLocaleDateString());
      console.log('Fecha en formato ISO:', fechaSeleccionada.toISOString());
      console.log('Día:', fechaSeleccionada.getDate());
      console.log('Mes:', fechaSeleccionada.getMonth() + 1);
      console.log('Año:', fechaSeleccionada.getFullYear());
    }
  };

  const handleClose = () => {
    navigate('/adminUsersPanel');
  };

  const agregarToken = async () => {
    try {
      const response = await fetch(SERVIDOR+'/api/nuevo-token', {
        method: "POST",
        body: JSON.stringify({
          token: userData.token,
          name: userData.name,
          email: userData.email,
          expirationDate : userData.expirationDate
        }),
        headers: {
          Accept: "application/json",
          "Content-type": "application/json",
        },
      });

      if (!response.ok) {
        throw new Error(`Error en la solicitud: ${response.error}`);
      }
      
      setTimeout(() => {
        alert('Token guardado correctamente');
        navigate('/userTable');
      }, 2000);
      
    } catch (error) {
      console.error('Error al hacer la solicitud:', error);
      alert('Error al guardar el token');
    }
  };

  if (!hasValidated) {
    return <div className="flex items-center justify-center h-screen">Validando acceso...</div>;
  }

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-50 to-gray-100 pt-32">
      <div className="max-w-[500px] mx-auto p-8 bg-white rounded-xl shadow-2xl">
        <h2 className="text-2xl font-bold text-[#697565] mb-6">Registro de Usuario</h2>
        
        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label className="block text-gray-700 mb-2">Nombre Completo</label>
            <input 
              type="text" 
              name="name"
              value={userData.name}
              onChange={handleInputChange}
              className="w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-[#697565]"
              required 
            />
          </div>

          <div>
            <label className="block text-gray-700 mb-2">Correo Electrónico</label>
            <input 
              type="email" 
              name="email"
              value={userData.email}
              onChange={handleInputChange}
              className="w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-[#697565]"
              required 
            />
          </div>

          <div>
            <label className="block text-gray-700 mb-2">Fecha de Caducidad</label>
            <input
              type="date"
              name="expirationDate"
              value={userData.expirationDate}
              onChange={handleInputChange}
              className="w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-[#697565]"
            />
          </div>

          <div>
            <label className="block text-gray-700 mb-2">Token de Acceso</label>
            <div className="flex space-x-2">
              <input 
                type="text" 
                name="token"
                value={userData.token}
                readOnly
                className="flex-grow px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-[#697565]"
                placeholder="Genere un token"
              />
              <button 
                type="button"
                onClick={generateToken}
                className="px-4 py-2 bg-gray-200 text-gray-700 rounded-lg hover:bg-gray-300 transition-colors"
              >
                Generar Token
              </button>
            </div>
          </div>

          <div className="flex justify-between space-x-4 pt-4">
            <button 
              type="button"
              onClick={handleClose}
              className="flex-grow bg-gray-200 text-gray-700 px-4 py-2 rounded-lg hover:bg-gray-300 transition-colors"
            >
              Cancelar
            </button>
            <button 
              type="submit"
              className="flex-grow bg-[#697565] text-white px-4 py-2 rounded-lg hover:bg-[#798575] transition-colors"
              onClick={agregarToken}
            >
              Registrar Usuario
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default UserRegistration;